const UserDashboard = ()=>{
    return (
        <p>
            hello normal user
        </p>
    )
}

export default UserDashboard;